var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyPortalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 103,
    viewBox: "0 0 127 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20698",
    "data-name": "Group 20698",
    transform: "translate(-414 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6497",
    "data-name": "Rectangle 6497",
    width: 127,
    height: 103,
    rx: 10,
    transform: "translate(414 361)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21191",
    "data-name": "Path 21191",
    d: "M78,74.9H75.3V31.2a2.006,2.006,0,0,0-2-2H53.1V23a2.006,2.006,0,0,0-2-2H26.7a2.006,2.006,0,0,0-2,2V74.9H22a2,2,0,0,0,0,4H78a2,2,0,0,0,0-4Zm-36.9,0H36.6V58h4.5Zm8-43.7V74.9H45.2V56a2.006,2.006,0,0,0-2-2H34.7a2.006,2.006,0,0,0-2,2V75H28.8V25.1H49.2v6.1Zm22.2,8.5H61.1a2,2,0,0,0,0,4H71.3V49H61.1a2,2,0,0,0,0,4H71.3v5.4H61.1a2,2,0,0,0,0,4H71.3v5.4H61.1a2,2,0,0,0,0,4H71.3V75H53.1V33.2H71.4v6.5Z",
    transform: "translate(427 362.674)",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyPortalIcon);
export default __webpack_public_path__ + "static/media/company_portal_icon.e06d9a54219645bc73737f503e125e49.svg";
export { ForwardRef as ReactComponent };